export default "Escape Attic opened in June 2018.";